import React, {useEffect, useState} from 'react';
import { Modal, Button } from 'antd';
import {useDispatch, useSelector} from "react-redux";
import {fetchCategoryFirst} from "@/redux/actions/home-mobile";
import {APIGetUserInfo, APIUserCategorySave} from "@/api";
import useDispatchAction from "@/hooks/useDisptachAction";
import {setUserInfo} from "@/redux/actions/home";
import CommonLoading from "@/components/CommonLoading";
import useLanguage from "@/hooks/useLanguage";

const CategorySelectModal = ({ visible, onCancel, onSelected, noSkip }) => {
  const dispatch = useDispatch();
  const dispatchAction = useDispatchAction({ setUserInfo });
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();
  const { categoryFirst } = useSelector((state) => {
    return state.categoryFirstInfo;
  });
  const handleSelect = (cat) => {
    if (selected.includes(cat)) {
      setSelected(selected.filter((c) => c !== cat));
      return;
    }
    setSelected([...selected, cat]);
  };

  useEffect(() => {
    if (visible && categoryFirst.length > 0){
      const list = [];
      categoryFirst.forEach((item) => {
        if ( onSelected.includes(item.name)){
          list.push(item.categoryId);
        }
      });
      setSelected(list);
    }
  }, [onSelected, visible, categoryFirst]);

  const handleReset = () => setSelected([]);


  const handleConfirm = () => {
    setLoading(true);
    APIUserCategorySave(JSON.stringify({ categoryIds: selected })).then(resp => {
      onCancel();
      setSelected([]);
      const token = localStorage.getItem("token");
      if (token) {
        APIGetUserInfo().then(async resp => {
          if (resp.data.user) {
            const user = resp.data.user;
            dispatchAction.setUserInfo(user);
            localStorage.setItem("user", JSON.stringify(user));
          }
        });
      }
    }).catch(e => {
      console.log('~e', e);
    }).finally(()=>{
      setLoading(false);
    });
  };

  useEffect(() => {
    if (!categoryFirst || categoryFirst?.length <= 0) {
      dispatch(fetchCategoryFirst());
    }
  }, []);

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      centered
      closable={false}
      width={800}
      rootClassName={"category_modal"}
    >
      <div className='rounded-[30px] relative p-0 shadow-xl'>
        {
          !noSkip &&  <div onClick={onCancel} className={"absolute right-0 top-[-53px] text-white opacity-[0.81] font-500 rounded-[24px] text-[20px] cursor-pointer bg-[#0D132CA8] h-[44px] px-[20px] flex items-center"}>{t('category_select.skip')}</div>
        }
        <div className='text-[18px] flex items-center font-500 text-white bg-[#454D6C] rounded-t-[32px] px-8 h-[94px]'>
          {t('category_select.title')}
        </div>
        <div className='flex flex-wrap bg-[#fff] justify-between gap-y-[17px] px-8 pt-[32px] pb-0'>
          {categoryFirst?.map((cat) => {
            const isSelected = selected.includes(cat.categoryId);
            return (
              <button
                key={cat.categoryId}
                disabled={selected.length >= 3 && !isSelected}
                className={`w-[230px] px-[12px] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center h-[45px] rounded-full text-[16px] font-500 transition-all duration-200
                  ${isSelected
                  ? 'bg-[#FDEFE9] text-[#FE7D15]'
                  : 'bg-[#F4F6FE] text-[#000000] hover:bg-[#e6e9f0]'} cursor-pointer`}
                onClick={() => handleSelect(cat.categoryId)}
              >
                <div className={"truncate"}>{cat.name}</div>
              </button>
            );
          })}
        </div>
        <div className='flex bg-[#fff]  justify-center gap-8 shadow rounded-b-[30px] p-[26px]'>
          <button
            className='w-40 h-12 rounded-full min-w-[220px] bg-[#EDF0FE] border-[#BDC9FB] border text-[#454D6C] text-[20px] font-500 border-none'
            onClick={handleReset}
          >
            {t('category_select.reset')}
          </button>
          <button
            disabled={loading}
            className='w-40 h-12 flex items-center justify-center rounded-full min-w-[220px] bg-gradient-to-r from-[#F76C4D] to-[#FE912C] text-white text-[20px] font-500 border-none disabled:opacity-50 disabled:cursor-not-allowed'
            onClick={handleConfirm}
          >
            {
              loading && <CommonLoading></CommonLoading>
            }
            {t('category_select.confirm')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CategorySelectModal;
